import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-retrato-foto',
  templateUrl: './retrato-foto.component.html',
  styleUrls: ['./retrato-foto.component.scss']
})
export class RetratoFotoComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle("EL RETRATO FOTOGRÁFICO EN LIMA (1860-1930)");
  }

  ngOnInit(): void {
  }

  slides = [
    { id: "https://hdl.handle.net/20.500.14428/46476", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006b.jpg", autor: "Juan Garland von Lotten", anno: "1883" },
    { id: "https://hdl.handle.net/20.500.14428/3401", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006c.jpg", autor: "María Rosa Garland Von Lotten", anno: "Ca. 1890" },
    { id: "https://hdl.handle.net/20.500.14428/20627", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006d.jpg", autor: "Corina Garland Von Lotten", anno: "1892" },
    { id: "https://hdl.handle.net/20.500.14428/59933", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006e.jpg", autor: "Alejandro Garland von Lotten", anno: "1895" },
    { id: "https://hdl.handle.net/20.500.14428/45998", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006f.jpg", autor: "Guillermo Garland von Lotten y su hija María Luisa", anno: "1901" },

  ];

  slides2 = [
    { id: "https://hdl.handle.net/20.500.14428/29342", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006g.jpg", autor: "Margarita e ¿Isabel? Garland da Ponte", anno: "Ca. 1900" },
    { id: "https://hdl.handle.net/20.500.14428/45998", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006h.jpg", autor: "Carlos Garland Higginson", anno: "1901" },
    { id: "https://hdl.handle.net/20.500.14428/29291", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006i.jpg", autor: "Juan Garland da Ponte", anno: "1902" },
    { id: "https://hdl.handle.net/20.500.14428/29305", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006j.jpg", autor: "Geraldo, Enrique y ¿Alfredo? Garland da Ponte", anno: "1902" },
    { id: "https://hdl.handle.net/20.500.14428/39599", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006k.jpg", autor: "Alejandro Graña Garland", anno: "1906" },
    { id: "https://hdl.handle.net/20.500.14428/29306", img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006l.jpg", autor: "María Teresa Garland Higginson", anno: "1908" },

  ];

  slides3 = [
    { img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006n.jpg", autor: "Eloyda, Enriqueta, Consuelo, María, Elvira, Corina, Luisa Garland Roel", anno: "1909" },
    { img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006o.jpg", autor: "Octavio y Luisa Tudela Garland", anno: "1922" },
    { img: "/assets/images/micrositio/micrositio3/ET02_MS03_FOT_img006m.jpg", autor: "Rosa “Mocha” Graña Garland", anno: "1930" },


  ];
  slideConfig = {
    "slidesToShow": 5, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 1
        }
      }


    ]
  };

  slideConfig2 = {
    "slidesToShow": 1, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 1
        }
      }


    ]
  };
  slideConfig3 = {
    "slidesToShow": 3, "slidesToScroll": 1, "responsive": [
      {
        'breakpoint': 600,
        'settings': {
          'slidesToShow': 1
        }
      }


    ]
  };
}
